// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withoutLabel .select__control {
    border: none;
    box-Shadow: "null";
    background: "#fff";
    outline: 0;
    width: 160px;
}
.withoutLabel .select__control .select__value-container{
    width: 130px;
}
.withoutLabel .select__control .select__indicators{
    width: 30px;
    position: relative;
    top: -10px;
    left: -55px;
        color: rgb(93 96 101 / var(--tw-text-opacity));
}
.withoutLabel .select__control.select__control--is-focused.select__control--menu-is-open {
    background: none;
}
.withoutLabel .select__control .select__single-value{
    font-size: 12px;
    font-weight: 500;
    color: rgb(93 96 101 / var(--tw-text-opacity));
}
.lang-size{
    font-size: 14px;
    font-weight: 600;
    color: rgb(52 56 63 / var(--tw-text-opacity));
}
.withoutLabel .select__menu{
    right:20px;
}`, "",{"version":3,"sources":["webpack://./src/components/GlobalCountry/index.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IAGV,YAAY;AAFhB;AAIA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;QACP,8CAA8C;AACtD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;AACA;IACI,UAAU;AACd","sourcesContent":[".withoutLabel .select__control {\n    border: none;\n    box-Shadow: \"null\";\n    background: \"#fff\";\n    outline: 0;\n}\n.withoutLabel .select__control{\n    width: 160px;\n}\n.withoutLabel .select__control .select__value-container{\n    width: 130px;\n}\n.withoutLabel .select__control .select__indicators{\n    width: 30px;\n    position: relative;\n    top: -10px;\n    left: -55px;\n        color: rgb(93 96 101 / var(--tw-text-opacity));\n}\n.withoutLabel .select__control.select__control--is-focused.select__control--menu-is-open {\n    background: none;\n}\n.withoutLabel .select__control .select__single-value{\n    font-size: 12px;\n    font-weight: 500;\n    color: rgb(93 96 101 / var(--tw-text-opacity));\n}\n.lang-size{\n    font-size: 14px;\n    font-weight: 600;\n    color: rgb(52 56 63 / var(--tw-text-opacity));\n}\n.withoutLabel .select__menu{\n    right:20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
